/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BatchSearchResultViewModel {
  datasetId?: string;
  batchId?: string;
  batchNumber?: number;
  checkNumberMatch?: boolean;
  checkNumber?: string | null;
  payorNameMatch?: boolean;
  payorName?: string | null;
  batchDateMatch?: boolean;
  batchDate?: string;
  postingDateMatch?: boolean;
  postingDate?: string;
  batchTypeMatch?: boolean;
  batchNumberMatch?: boolean;
  batchType?: string | null;
  readonly score?: number;
}
